/**
 * Definition of z-index values to be used across application.
 * Final values are yet to be defined.
 */
export enum StackingContextLevel {
  AppHeader = 10,
  Preview = 900,
  Tooltip = 1000,
  Dropdown = 2000,
  ModalOverlay = 3000,
  Modal = 4000,
  ModalTooltip = 5000,
  ModalDropdown = 6000,
  ContentOverlay = 7000,
  ContentOverlayTooltip = 8000,
  ContentOverlayDropdown = 9000,
  FullOverlay = 10000,
  ScrollbarOverlay = 100000,
  OverChatWidget = 10000000000000,
}
